import React from "react";
import HorseLink from "../../common/HorseLink";

export function AdjustedByLink({
  url,
  title,
}: {
  readonly url?: string;
  readonly title: string;
}): React.ReactElement | string {
  if (url?.startsWith("https://")) {
    return (
      <a href={url} onClick={navigateToShopifyAdmin}>
        {title}
      </a>
    );
  } else if (url) {
    return <HorseLink url={url}>{title}</HorseLink>;
  } else {
    return title;
  }
}

function navigateToShopifyAdmin(event: React.MouseEvent<HTMLAnchorElement>): void {
  if (event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

  event.preventDefault();
  const parsedUrl = new URL(event.currentTarget.href);
  let pathname = parsedUrl.pathname.startsWith("/") ? parsedUrl.pathname.slice(1) : parsedUrl.pathname;
  const adminPathPrefix = "admin/";
  if (pathname.startsWith(adminPathPrefix)) {
    pathname = pathname.slice(adminPathPrefix.length);
  }
  window.open(`shopify://admin/${pathname}`, "_top");
}
